export async function sendMessageToBot(message, history = []) {
  const response = await fetch("https://naveen07garg-airlinechatbot.hf.space/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, history })
  });

  return response.json();  // {answer: "...", citations: [...] }
}
